import { render, staticRenderFns } from "./GlobalTapSupervisor.vue?vue&type=template&id=c55e0f2c&"
import script from "./GlobalTapSupervisor.vue?vue&type=script&lang=js&"
export * from "./GlobalTapSupervisor.vue?vue&type=script&lang=js&"
import style0 from "./GlobalTapSupervisor.vue?vue&type=style&index=0&id=c55e0f2c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports